export const makeTellentSelector = (selector: string): `tellent-${string}` => {
  if (!selector.startsWith('x-')) {
    console.warn('Selectors for tellent components should start with "x-", but got:', selector);
  }
  return <any>selector.replace('x-', 'tellent-');
};
